import React from 'react';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-teal-50 to-white pt-8 pb-12" data-id="element-143">
      <div className="max-w-3xl mx-auto px-4" data-id="element-144">
        
        <h1 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-4" data-id="element-145">
          Wie ich von 12 Schmerztabletten täglich zu einem Leben ohne
          Medikamente kam
        </h1>
        <h2 className="text-xl md:text-2xl font-serif italic text-gray-700 mb-6" data-id="element-146">
          (mein deutscher Arzt konnte die Röntgenbilder nicht glauben)
        </h2>
        <div className="text-lg text-gray-600 mb-6" data-id="element-147">
          Eine schockierende Verwandlung, die zum Nachdenken anregt
        </div>
        <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-148">
          <span data-id="element-149">Düsseldorf, Deutschland</span>
          <span className="mx-2" data-id="element-150">•</span>
          <span data-id="element-151">Veröffentlicht: Juni 2025</span>
        </div>
        <div className="border-l-4 border-teal-600 pl-4 italic text-lg text-gray-700 mb-8" data-id="element-152">
          "Mein Name ist Angela Weber. Ich bin 47 Jahre alt, Buchhalterin bei
          einem mittelständischen Unternehmen in Düsseldorf, Mutter von zwei
          Kindern - und ich war vier Jahre lang eine Tabletten-Abhängige."
        </div>
        <div className="flex justify-center mb-8" data-id="element-153">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uBUqETSzjptQhiCuTLuBGe/4-1.webp" alt="Arzt markiert Schmerzpunkte am Fuß" className="w-full max-w-2xl rounded-lg shadow-lg" data-id="element-154" />
        </div>
      </div>
    </section>;
}